import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function ProcessingStatusIcon({ className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M14.6667 8C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33333 11.6819 1.33333 8C1.33333 4.3181 4.3181 1.33333 8 1.33333C11.6819 1.33333 14.6667 4.3181 14.6667 8ZM3.66667 8C3.66667 10.3932 5.60677 12.3333 8 12.3333C10.3932 12.3333 12.3333 10.3932 12.3333 8C12.3333 5.60677 10.3932 3.66667 8 3.66667C5.60677 3.66667 3.66667 5.60677 3.66667 8Z"
        fill="#E6E7EB"
      />
      <path
        d="M8 1.33333C8.87548 1.33333 9.74238 1.50577 10.5512 1.8408C11.3601 2.17584 12.095 2.6669 12.714 3.28596C13.3331 3.90501 13.8242 4.63994 14.1592 5.44878C14.4942 6.25762 14.6667 7.12452 14.6667 8L12.3333 8C12.3333 7.43094 12.2212 6.86745 12.0035 6.34171C11.7857 5.81596 11.4665 5.33826 11.0641 4.93587C10.6617 4.53348 10.184 4.21429 9.65829 3.99652C9.13255 3.77875 8.56906 3.66667 8 3.66667L8 1.33333Z"
        fill="#1237B5"
      />
    </svg>
  );
}

export default ProcessingStatusIcon;
